import * as Yup from 'yup';
import { TargetConfigMetaData } from '../models';
import Marketo from './index';

export const MARKETO_CONFIG: TargetConfigMetaData = {
  formComponent: Marketo,

  initialValues: {
    clientID: '',
    clientSecret: '',
    subDomain: ''
  },

  validationSchema: Yup.object({
    clientID: Yup.string().trim().required(),
    clientSecret: Yup.string().trim().required(),
    subDomain: Yup.string().trim().required()
  }),

  fieldNameMapping: {
    clientID: 'client-id',
    clientSecret: 'client-secret',
    subDomain: 'api-endpoint'
  }
};
